import React from "react";
import PropTypes from "prop-types";
import Card from "../card/Card";
import List from "../list/List";
import ListItem from "../list-item/ListItem";

const LienHolder = (props) => {
    const { direction, lienHolderData } = props;

    const formatPhoneNumber = (phoneNumberString) => {
        let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{1,3})(\d{0,3})(\d{0,4})(\d{0,4})$/);
        if (match) {
            cleaned = `(${match[1]}${match[2] ? ') ' : ''}${match[2]}${match[3] ? '-' : ''}${match[3]}${match[4] ? ' x' : ''}${match[4]}`;
        }
        return cleaned;
    }

    const displayData = () => {
        if (lienHolderData) {
            return (
                <div className="card-container">
                    <Card cardTitle="Lien Holder" cardIcon="fas fa-university">
                        <div className={`d-flex pl-31 flex-wrap flex-${direction}`}>
                            <List>
                                <div className="card-col__1 mt-9">
                                    <ListItem itemKey="Lienholder Name" itemValue={lienHolderData.name} />
                                </div>
                                <div className="card-col__1 mt-11">
                                    <ListItem itemKey="Lienholder Address" itemValue={lienHolderData.address1} />
                                    <ListItem itemValue={lienHolderData.address2} />
                                </div>
                                <div className="card-col__1 mt-11">
                                    <ListItem itemKey="City" itemValue={lienHolderData.city} />
                                </div>
                                <div className="card-col__1 mt-11 d-flex">
                                    <div className="w-100">
                                        <ListItem itemKey="State" itemValue={lienHolderData.state} />
                                    </div>
                                    <div className="w-100">
                                        <ListItem itemKey="Zip/Postal Code" itemValue={lienHolderData.zipCode} />
                                    </div>
                                </div>
                                <div className="card-col__1 mt-11">
                                    <ListItem itemKey="Lienholder Phone" itemValue={formatPhoneNumber(lienHolderData.phone)} />
                                </div>
                            </List>
                        </div>
                    </Card>
                </div>
            )
        }
    }

    return (
        <React.Fragment>
            {displayData()}
        </React.Fragment>
    )
};

LienHolder.propTypes = {
    direction: PropTypes.string,
    lienHolderData: PropTypes.object
}

export default LienHolder;